/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum Severity {
    ERROR = 'Error',
    WARNING = 'Warning',
    INFO = 'Info',
}
